/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ROUTES from 'constants/routes';
import { ReactComponent as AppError } from 'assets/svg/global/app-error.svg';
import { getSessionAuthorized } from 'app/session/selectors';
import Button, { buttonColors, buttonSizes } from 'components/Button';
import { ContentWrap, SectionWrap } from 'components/Layout';
import { PageNotFoundWrap, ImageWrap, MessageWrap } from './styles';

const PageNotFound = ({ goBackToMain }) => (
  <ContentWrap>
    <SectionWrap>
      <PageNotFoundWrap>
        <ImageWrap>
          <AppError />
        </ImageWrap>
        <MessageWrap>
          <h1>Oops! Page not found.</h1>
          <p>Sorry, we couldn't find the page you are looking for.</p>
          <Button
            size={buttonSizes.large}
            color={buttonColors.secondary}
            onClick={() => goBackToMain()}
          >
            <span>Go Back To Main Page</span>
          </Button>
        </MessageWrap>
      </PageNotFoundWrap>
    </SectionWrap>
  </ContentWrap>
);

PageNotFound.propTypes = {
  goBackToMain: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  authenticated: getSessionAuthorized(state),
});

const mapDispatchToProps = {
  goToDashboard: () => push(ROUTES.DASHBOARD),
  goToLogin: () => push(ROUTES.LOGIN.BASE),
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { authenticated } = stateProps;
  const { goToDashboard, goToLogin } = dispatchProps;
  const goBackToMain = authenticated ? goToDashboard : goToLogin;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    goBackToMain,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PageNotFound);